import { render, staticRenderFns } from "./signatureAdd.vue?vue&type=template&id=57145c9e&scoped=true&"
import script from "./signatureAdd.vue?vue&type=script&lang=js&"
export * from "./signatureAdd.vue?vue&type=script&lang=js&"
import style0 from "./signatureAdd.vue?vue&type=style&index=0&id=57145c9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57145c9e",
  null
  
)

export default component.exports